module.exports = __webpack_public_path__ + "static/media/logo.06389454.jpg";